import React from "react"
import { Link, RichText, Date } from 'prismic-reactjs';

import styled from "styled-components";
import * as vars from "../style/vars";
import { above, below } from "../style/functions";
import shader from 'shader'
import Header from "../components/header.js"

import AppleAppStore from "../svg/apple-app-store-badge.svg"
import GoogleAppStore from "../svg/google-play-badge.svg"
import StickyEnquire from "../components/sticky-enquire";



class errorPage extends React.Component {

	componentWillMount() {
        this.props.updateSlug(this.props.data.prismicYarrabendResidentsApp.uid);
		this.props.updateMeta(this.props.data.prismicYarrabendResidentsApp.data.meta_title.text, this.props.data.prismicYarrabendResidentsApp.data.meta_description);
        this.props.togglePopup(false);
        this.props.updatePageType(this.props.data.prismicYarrabendResidentsApp.type);
        this.props.updateProductHide(false);
        this.props.updateFooterVisible(true);
	}
	render() {



		return (
			<div>
				<Header togglePopup={this.props.togglePopup} theme="dark" menu={this.props.data.prismicMainNavigation.data} />
                <StickyEnquire theme="light" togglePopupState={this.props.popupVisible} togglePopup={this.props.togglePopup} utm={this.props.utm} updateFormDetails={(first_name,last_name,phone,email) => this.props.updateFormDetails(first_name,last_name,phone,email)}/>

                <GreyBG
                    className={`bg dark`}>
                    <GreyHeader className="grid">
                        <div className="inner">
                            <div className="col col-12" >
                                <div className="col col-12 desktop-hide">
                                    <img className="hero-image" src={this.props.data.prismicYarrabendResidentsApp.data.intro_image.url} />
                                </div>
                                <div className="col col-06">

                                    <div dangerouslySetInnerHTML={{ __html: this.props.data.prismicYarrabendResidentsApp.data.title.html }} />
                                    <div
                                        dangerouslySetInnerHTML={{
                                        __html: this.props.data.prismicYarrabendResidentsApp.data.intro_paragraph.html
                                        }}
                                    />

                                    <div className="col col-12 btn-wrapper">
                                        <a target="_blank" className="btn btn--outline" href={this.props.data.prismicYarrabendResidentsApp.data.download_the_app_guide.url}>Download the App Guide</a>
                                    </div>
                                    <div className="col col-12 btn-app-wrapper">
                                        <a target="_blank" className="btn--image btn--ios" href={this.props.data.prismicYarrabendResidentsApp.data.app_link___ios.url}>
                                            <img src={AppleAppStore} alt="Our app is now available on Apple App Store" />
                                        </a>
                                        <a  target="_blank" className="btn--image btn--android" href={this.props.data.prismicYarrabendResidentsApp.data.app_link___android.url}>
                                            <img src={GoogleAppStore} alt="Our app is now available on Google Play" />
                                        </a>
                                    </div>

                                    <div className="col col-12 app-features" dangerouslySetInnerHTML={{
                                        __html: this.props.data.prismicYarrabendResidentsApp.data.app_features.html
                                    }}
                                    />

                                </div>
                                <div className="col col-06 mobile-hide">
                                    <img className="hero-image" src={this.props.data.prismicYarrabendResidentsApp.data.intro_image.url} />
                                </div>
                            </div>


                        </div>
                    </GreyHeader>
                </GreyBG>

                <LAG className="grid">
                    <div className="inner">
                        <div className="col col-12 local-area-guide" >
                            <div className="col col-06 col-content" >
                                <div className="content-wrap" >
                                    <div
                                            dangerouslySetInnerHTML={{
                                            __html: this.props.data.prismicYarrabendResidentsApp.data.local_area_guide.html
                                            }}
                                        />
                                    </div>
                                </div>
                            <div className="col col-06" >
                                <img src={this.props.data.prismicYarrabendResidentsApp.data.local_area_guide_image.url} />
                            </div>
                        </div>
                    </div>
                </LAG>

			</div>

		)
	}
}




export default errorPage

const GreyBG = styled.div`
:after {
    display:none;
}

h1{
    ${above.tablet`
    margin-top: 262px;
    `}
    ${below.desktop`
        margin-top: 21.833vw
    `}
    ${below.tablet`
        margin-top: 0
    `}

    font-size: 10rem;
    line-height:9rem;
    padding-bottom: 0.45em;


    ${below.giant`
    font-size: 10.7rem;
    line-height:9.8rem;
    `}
    ${below.mid`
    font-size: 9.7rem;
    line-height:8.8rem;
    `}
    ${below.desktop`
        font-size: 7.5rem;
        line-height: 6.5rem;
    `}
    ${below.tablet`
        font-size: 8rem;
        padding-bottom: ${(vars.padding.inner)}rem;
        line-height: 1.1;
    `}
    ${below.mobile`
        font-size: 4rem;
    `}
    ${below.xs`
        font-size: 3rem;
    `}
}

img{
    &.hero-image{
        width:100%;
        ${above.tablet`
        max-width: 562px;
        margin-left: 31px;
        margin-top: 154px;
        `}

        ${below.tablet`
        max-width: 150px;
        margin: 0 auto ;
        padding-top:8em;
        padding-bottom:4em;
        display:block;
        `}
    }
}

.btn--image{
    :first-child{
        margin-right:2em;
    }

    :hover{
        img{
            opacity:.7;
        }
    }

    img{
        height:54px;
        ${below.tablet`
        height:42px;
        `}
        width:auto;
        display:inline-block;
    }
}

p{
    font-size: 2.4rem;
    letter-spacing: -0.03em;
    padding-bottom: 1.05rem;
    ${above.tablet`
    padding-right: 3rem;
    `}
    line-height:1.18;
    :last-child{
        padding-bottom:0;
    }
}
.btn-app-wrapper{
    margin-top:2em;
}
.btn-wrapper{
    margin-top: 6.2em;
    ${below.tablet`
    margin-top: 3em;
    `}
}
.btn{
    display:inline-block;
    font-size:2.5rem;
    border: 2px solid #fff;
    padding: .5em 1em;
    text-decoration:none;
    letter-spacing: -0.045em;
    background-color: transparent;
    transition: background-color .3s, color .3s;
    :hover{
        background-color:#fff;
        color:#3f3e3e;
        transition: background-color .3s, color .3s;
    }


}

.app-features{
    margin-top: 8.4em;
    border-left: 1px solid #fff;
    padding: 2.3em 3em;
    margin-bottom: 12em;

    ${below.tablet`
            padding-top: 3em;
            padding-bottom: 3em;
            margin-bottom: 3em;
            margin-top: 3em;
        `}

    h2{
        letter-spacing: -.04em;

        ${above.giant`
            font-size: 4.8rem;
        `}
    }

    ul {
        list-style: none;
        padding-left: 0;
        margin-left:0;
        font-size: 2.4rem;
        letter-spacing: -0.03em;

        ${above.tablet`
        margin-top: 0.9em;
        `}
    }

    ul > li {
        // margin-left: 15px;
        margin-left: 1.9em;
        position:relative;
    }

    ul > li::before {
        content: "-";
        position: absolute;
        height: 1em;
        top: 0;
        left: -1em;
        // margin-left: -15px;
    }

}



`;

const LAG = styled.div`


    .local-area-guide{


        ${above.tablet`
            display: flex;
            align-items: center;
            justify-content: center;
        `}
        padding-top: 7.4em;
        padding-bottom: 6.2em;

        ${below.tablet`
            padding-top: 3em;
            padding-bottom: 3em;
        `}

        .content-wrap{
            padding: 2.3em 3em;
            border-left: 1px solid #3f3e3e;
            max-width: 550px;
        }

        h2{
            padding-bottom: 0.6em;
            letter-spacing: -.04em;
            ${above.giant`
            font-size: 4.8rem;
        `}
        }
        p{
            font-size: 2.4rem;
            letter-spacing: 0;
            padding-bottom: 1.05rem;
            padding-right: 3rem;
            line-height:1.3;
            :last-child{
                padding-bottom:0;
            }

            a:not(.link-email):after {
                display:none;
            }

            a{
                margin-top: 1em;
                display: inline-block;
            }
        }
        img{
            ${above.tablet`
            padding-right:8em;
            `}

            ${below.tablet`
            margin-top: 1.75rem;
            `}
        }


        ${below.tablet`
            .col-06{
                width:100%;
            }
        `}


    }
`;
const GreyHeader = styled.div`


${below.tablet`


    .col-06{
        width:100%;
    }

    .col-12{
        width:100%;
        float:none;
    }



    .mobile-hide{
        display: none
    }


  `}
  ${above.tablet`
  .desktop-hide{
    display: none
}
  `}

`;
const DownArrow = styled.div`



`

export const pageQuery = graphql`
   query yarrabendResidentsApp($id: String) {
      prismicYarrabendResidentsApp(id: { eq: $id }) {
        id
        uid
        type
		dataString
		data {
			meta_title {
				html
				text
			}
            meta_description
            title {
              html
              text
            }
            intro_paragraph {
              html
              text
            }
            intro_image {
              url
            }
            download_the_app_guide {
              url
            }
            app_link___ios {
              url
            }
            app_link___android {
              url
            }
            app_features {
              html
              text
            }
            local_area_guide {
              html
              text
            }
            local_area_guide_image {
              url
            }
            meta_title {
              html
              text
            }
		}
	}
	prismicMainNavigation {
		id
		dataString
		data {
		  display_name {
			html
			text
		  }
		  nav {
			slice_type
			primary {
			  label {
				text
			  }
			  link {
				text
			  }
			}
			items {
			  sub_nav_link_label {
				text
			  }
			  sub_nav_link {
				text
			  }
			}
		  }
		}
	  }
   }
`



// WEBPACK FOOTER //
// ./src/templates/yarrabendResidentsApp.js